export default __webpack_public_path__ + "static/media/manager.f1f9377f.png";